/** Human-readable label for template preview rows (seed `type` values). */
export function formatTemplateQuestionType(type: string): string {
  switch (type) {
    case 'multiple_choice':
      return 'Multiple choice'
    case 'picture_choice':
      return 'Picture choice'
    case 'checkbox':
      return 'Checkbox'
    case 'ranking':
      return 'Ranking'
    case 'rating':
      return 'Rating'
    case 'likert':
      return 'Likert scale'
    case 'slider':
      return 'Slider'
    case 'short_text':
      return 'Short text'
    case 'long_text':
      return 'Long text'
    case 'yes_no':
      return 'Yes / No'
    case 'dropdown':
      return 'Dropdown'
    case 'date':
      return 'Date'
    case 'video':
      return 'Video'
    default:
      return type.replaceAll('_', ' ')
  }
}
